(function() {
	var testObject = {};

	if (!(Object.setPrototypeOf || testObject.__proto__)) {
		var nativeGetPrototypeOf = Object.getPrototypeOf;

		Object.getPrototypeOf = function(object) {
			if (object.__proto__) {
				return object.__proto__;
			} else {
				return nativeGetPrototypeOf.call(Object, object);
			}
		}
	}
})();



/*****************
 ** WEBPACK FOOTER
 ** ./~/ima.js-babel6-polyfill/index.js
 ** module id = 574
 ** module chunks = 0
 **/